import type { UpdateMe, User } from "@/types/user";
import coreApi from "../coreApi";
import { API_ENDPOINTS } from "../endpoints";

export const meService = {
  getMe: async (): Promise<User> => {
    try {
      return await coreApi.get<User>(`${API_ENDPOINTS.ME}`);
    } catch (error) {
      console.error("Failed to fetch current user:", error);
      throw error;
    }
  },
  updateMe: async (userData: Partial<UpdateMe>): Promise<User> => {
    try {
      return await coreApi.put<User>(`${API_ENDPOINTS.ME}`, userData);
    } catch (error) {
      console.error("Failed to update current user:", error);
      throw error;
    }
  },
};
